import { constants, rem, Styles, theme } from '@/styles';

export const styles: Styles = {
  borderRadius: constants.borderRadius.small,
  border: `1px solid ${theme.borderPrimary}`,
  paddingLeft: constants.offset.medium,
  paddingRight: constants.offset.xlarge,
  height: constants.inputHeight,
  width: '100%',
  color: theme.textPrimary,
  appearance: 'none',
  backgroundImage: 'url(/images/icons/mdi-chevron-down-primary.svg)',
  backgroundPosition: `right ${constants.offset.xsmall}px center`,
  backgroundRepeat: 'no-repeat',
  transitionProperty: 'border-color, box-shadow',
  transitionDuration: '.2s',

  '.select-placeholder': {
    fontStyle: 'italic',
    color: 'theme.textThird',
    fontSize: rem(constants.fontSize.medium),
  },

  '&:active:enabled, &:focus:enabled': {
    border: `1px solid ${theme.borderPrimaryActive}`,
    boxShadow: `0 0 1px 1px ${theme.borderPrimaryActive} inset`,
    outline: 'none',
  },

  '&:disabled': {
    backgroundColor: theme.backgroundPrimaryDisabled,
    backgroundImage: 'url(/images/icons/mdi-chevron-down-grey.svg)',
    color: theme.textDisabled,

    '.select-placeholder': {
      color: theme.textDisabled,
    },
  },
};
